// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__25LLe","disabled":"Button_disabled__16p-U"};